export interface IUserTokenLoginInfo {
  token: string;
  refresh_token: string;
  session_id: string;
  legacy_token: string;
}

interface ILocalStorageItems {
  'device_token': string | null;
  'user_token_login_info': IUserTokenLoginInfo | null;
  'user-storage': any;
  'is_logged_out_by_inactivity': boolean;
}

const setLocalStorageItem = <K extends keyof ILocalStorageItems>({
  key,
  value,
}: {
  key: K;
  value: ILocalStorageItems[K];
}): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

const getLocalStorageItem = <K extends keyof ILocalStorageItems>({
  key,
}: {
  key: K;
}): ILocalStorageItems[K] | null => {
  const localStorageItem = localStorage.getItem(key) ?? null;

  return localStorageItem
    ? (JSON.parse(localStorageItem) as ILocalStorageItems[K])
    : null;
};

const removeLocalStorageItem = <K extends keyof ILocalStorageItems>({
  key,
}: {
  key: K;
}): void => {
  localStorage.removeItem(key);
};

export const localStorageService = {
  setLocalStorageItem,
  getLocalStorageItem,
  removeLocalStorageItem,
};
